/*eslint no-extend-native: ["error", { "exceptions": ["Date"] }]*/
import DevProjectAPI from "../api/DevProject";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { hideLoader, showLoader } from "../util/loader/CustomLoader";
import { CustomToast } from "../util/custom-toast/CustomToast";
import { useHistory } from "react-router";

Date.prototype.yyyymmdd = function () {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [
        this.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
    ].join('-');
};

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
function formatDate(d) {
  let date = new Date(d);
  var dd = date.getDate();
  var mm = monthNames[date.getMonth()];
  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return (d = dd + " " + mm + " " + yyyy);
}

export const useCreateProject = (setShowNewProject,setShowDEA) => {
    const queryClient = useQueryClient();
    const { mutate, isSuccess, isError, isLoading, error,  data } = useMutation(
        async (values) => {
            const data = {
                ...values,
                alphaReleaseDate: values.alphaReleaseDate.yyyymmdd(),
                betaReleaseDate: values.betaReleaseDate.yyyymmdd(),
                prodReleaseDate: values.prodReleaseDate.yyyymmdd(),
                developerKit: parseInt(values.developerKit),
            };
            const api = new DevProjectAPI();

      const res= await api.createProject(data);
      return res.data.data;
    },
    {
      onMutate: () => {
        console.log("loading");
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
        setShowNewProject(false);
        setShowDEA(true);
        queryClient.invalidateQueries("allprojects", { exact: true });
      },
      onError: (error) => {
        console.log(error);
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, isSuccess, isError, isLoading, error,data };
};
export const useOneProject = (projectid, setViewDetails) => {
  const history = useHistory();
  const { data, isLoading, isError } = useQuery(
    ["oneproject", projectid],
    async () => {
      let api = new DevProjectAPI();
      showLoader();
      const res = await api.getOneProject(projectid);
      const project = {
        ...res.data.data,
        alphaReleaseDate: new Date(res.data.data.alphaReleaseDate),
        betaReleaseDate: new Date(res.data.data.betaReleaseDate),
        prodReleaseDate: new Date(res.data.data.prodReleaseDate),
        developerKit: res.data.data.developerKit.toString(),
      };
      setViewDetails(project.status === 0);
      hideLoader();
      return project;
    },
    {
      onError: (error) => {
        if(error.response?.data.error_code === "E08053"){
          CustomToast(error.response.data.message);
          history.push('/')
        }else{
        history.replace(history.location.pathname, {
          errorStatusCode: error.response ? error.response.status : 500,
        })}
        hideLoader();
      },
    }
  );
  return { data, isLoading, isError };
};

export const useAllProjects = () => {
  const history = useHistory();
  const { data, isLoading, isError } = useQuery(
    "allprojects",
    async () => {
      let api = new DevProjectAPI();
      const res = await api.getAllProject();
      return res.data.data;
    },
    {
      onError: (error) => {
        history.replace(history.location.pathname, {
          errorStatusCode: error.response ? error.response.status : 500,
        });
      },
    }
  );
  return { data, isLoading, isError };
};

export const useProjectAppCount = (projectId,projectStatus,appOs) => {
  const history = useHistory();
  const { mutate, data, isLoading, isError } = useMutation(
    ["allApps",projectId,projectStatus],
    async () => {
      let api = new DevProjectAPI();
      const res = await api.getProjectCount(projectId,projectStatus,appOs);
      return res?.data?.data;
    },
    {
      onMutate: ()=>{
        showLoader()
      },
      onSuccess: ()=>{
        hideLoader()
      },
      onError: (error) => {
        history.replace(history.location.pathname, {
          errorStatusCode: error.response ? error.response.status : 500,
        });
      },
    }
  );
  return { mutate, data, isLoading, isError };
};

export const usePendingApps = () => {
  const history = useHistory();
  const { data, isLoading, isError } = useQuery(
    "pendingapps",
    async () => {
      let api = new DevProjectAPI();
      const res = await api.getPendingApps();
      const data = res.data.data.map((item) => ({
        ...item,
        created_at: formatDate(item.created_at),
      }));
      return data;
    },
    {
      onError: (error) => {
        history.replace(history.location.pathname, {
          errorStatusCode: error.response ? error.response.status : 500,
        });
      },
    }
  );
  return { data, isLoading, isError };
};
export const useUploadDEA = (projectid, DEAfile, setShowDEA) => {
    const queryClient = useQueryClient();
    const { mutate, isSuccess, isError, isLoading, error } = useMutation(
        async () => {
            const api = new DevProjectAPI();

      await api.uploadDEA(projectid, { deaUrl: DEAfile.url });
    },
    {
      onMutate: () => {
        console.log("loading");
        showLoader();
      },
      onSuccess: () => {
        hideLoader();
        CustomToast("Your Project application has been sent for approval");
        queryClient.invalidateQueries("allprojects", { exact: true });
        setShowDEA(false);
      },
      onError: (error) => {
        console.log(error);
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, isSuccess, isError, isLoading, error };
};
